import React from "react";
import "../../Styles/NewAboutus.css";
import { Col, Container, Row } from "react-bootstrap";

const DownloadSection = () => {
  return (
    <div className="new-home-section8 pt-5 mt-5">
      <Container>
        <h3 className="new-home-s8-outline">DOWNLOAD THE APP NOW</h3>
      </Container>
      <div className="new-home-colored-div">
        <img
          src="assets\images\newdesign\s8cut.png"
          style={{ height: "100%", zIndex: -1, opacity: 0.4 }}
          className="new-home-colored-img img-fluid"
          alt=""
        />
        <Container>
          <Row className="new-home-s8-download">
            <Col>
              <div className="py-5">
                <p className="new-home-s8-header mb-1">Download the app now</p>
                <p className="new-home-s8-small">application available on</p>
                <div className="d-flex gap-3 mb-2">
                  <a href="https://play.google.com/store/apps/details?id=com.espsofttech.stepmint&hl=en_IN" target="_blank" div className="new-home-s8btn px-3 py-2">
                    {" "}
                    <img src="assets\images\newdesign\playstore.svg" alt="" />
                  </a>
                  <a target="_blank" href="https://apps.apple.com/in/app/step-mint/id6473780792" className="new-home-s8btn px-3 py-2">
                    {" "}
                    <img src="assets\images\newdesign\apple.svg" alt="" />
                  </a>
                </div>
                <div className="d-flex align-items-center">
                  <img src="assets\images\newdesign\qr.svg" alt="" />
                  <p className="mb-0">Scan QR code to join community</p>
                </div>
              </div>
            </Col>
            <Col>
              <div className="w-100 d-flex justify-content-center">
                <img
                  src="assets\images\newdesign\phone2.png"
                  className="img-fluid"
                  style={{ marginTop: "-20%" }}
                  alt=""
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default DownloadSection;
